import React from "react";
import { _colorText, _sizeText } from "../../core/core";
import { Divider } from "../Divider/Divider";
import { Text } from "../texts/text";
import "./Tab.css";

interface TabProps {
    stroke?: boolean;
    active?: boolean;
    onClick?: () => void;
    sizeText?: _sizeText;
    children?: React.ReactNode;
    [key: string]: any; // Дополнительные пропсы
}

export const TabButton: React.FC<TabProps> = ({
    stroke = true,
    active = false,
    onClick = () => { },
    sizeText = _sizeText.s,
    children,
    ...props
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <button onClick={handleClick} className={`tab tab-${active}`} {...props}>
            <div className="tab-body">
                <Text size={_sizeText.s} color={active ? _colorText.black : _colorText.neutral}>{children}</Text>
            </div>
            {stroke && <Divider />}
        </button>
    );
};
